import DataNotFound from './DataNotFound';

export default DataNotFound;
